export function getLocalStorageItem<T>(key: string): T | null {
    const item = localStorage.getItem(key)
    try {
        return item ? (JSON.parse(item) as T) : null
    } catch (e) {
        console.error(`Error parsing localStorage item for key "${key}":`, e)
        return null
    }
}

export function setLocalStorageItem<T>(key: string, data: T): void {
    try {
        localStorage.setItem(key, JSON.stringify(data))
    } catch (e) {
        console.error(`Error setting localStorage item for key "${key}":`, e)
    }
}
